import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ApplyBuyInfo from '@/types/table/applyBuyInfo';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ApplyBuyInfoData extends ApplyBuyInfo {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ApplyBuyInfoController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ApplyBuyInfoData>>(API_CONTEXT + '/app/applyBuyInfo/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ApplyBuyInfoData>(API_CONTEXT + '/app/applyBuyInfo/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/applyBuyInfo/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/applyBuyInfo/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/applyBuyInfo/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/deleteBatch', params, httpOptions);
  }
  static startOnlyApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/startOnly/applyBuyInfo', params, httpOptions);
  }
  static startWithBusinessKeyApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/startWithBusinessKey/applyBuyInfo', params, httpOptions);
  }
  static startAndTakeUserTaskApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/startAndTakeUserTask/applyBuyInfo', params, httpOptions);
  }
  static startAndSaveDraftApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/startAndSaveDraft/applyBuyInfo', params, httpOptions);
  }
  static submitUserTaskApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/submitUserTask/applyBuyInfo', params, httpOptions);
  }
  static viewTaskBusinessDataApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/applyBuyInfo/viewTaskBusinessData/applyBuyInfo', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/applyBuyInfo/viewHistoricTaskBusinessData/applyBuyInfo', params, httpOptions);
  }
  static listWorkOrderApplyBuyInfo(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/applyBuyInfo/listWorkOrder/applyBuyInfo', params, httpOptions);
  }
}
